export default __webpack_public_path__ + "static/media/ship.889a27cd.svg";